import { render } from "./BuyMembershipPlan.vue?vue&type=template&id=18b5bab9"
import script from "./BuyMembershipPlan.vue?vue&type=script&lang=js"
export * from "./BuyMembershipPlan.vue?vue&type=script&lang=js"

import exportComponent from "/__w/system/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__